import { render, staticRenderFns } from "./FireplaceModule.vue?vue&type=template&id=c79bcb4a&scoped=true&"
import script from "./FireplaceModule.vue?vue&type=script&lang=js&"
export * from "./FireplaceModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79bcb4a",
  null
  
)

export default component.exports